const OAUTH_SERVICE_SUPPORTED_SLUGS = [
  'personas-facebook-ads',
  'facebook-custom-audiences',
  'adwords-remarketing-lists'
]

// this currently matches OAUTH_SERVICE_SUPPORTED_SLUGS but it will
// change as new providers are added
const OAUTH_PROVIDERS_WITH_ACCOUNTS = [
  'personas-facebook-ads',
  'facebook-custom-audiences',

  'adwords-remarketing-lists'
]

const SLUGS_TO_PROVIDERS = {
  'personas-facebook-ads': 'facebook',
  'facebook-custom-audiences': 'facebook',
  'adwords-remarketing-lists': 'google'
}

export const getProviderBySlug = metadataSlug =>
  SLUGS_TO_PROVIDERS[metadataSlug]
export const isOauthServiceSupported = metadataSlug =>
  OAUTH_SERVICE_SUPPORTED_SLUGS.includes(metadataSlug)
export const hasAccounts = metadataSlug =>
  OAUTH_PROVIDERS_WITH_ACCOUNTS.includes(metadataSlug)
